import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { Role } from 'domains/models/team_user/role';
import { ViewerItem } from 'presentations/api/schema/user';
import {
  servicePaymentPath,
  serviceListPath,
  serviceTaxRateListPath,
  serviceBusinessProfilePath,
} from 'presentations/routes/path';
import {
  isInElectron,
  isiOSApp as isiOSAppFunc,
} from 'presentations/views/helpers/electron';

interface Props {
  viewer: ViewerItem;
}

export const useDashboardServiceNavigation = (props: Props) => {
  const router = useRouter();

  const onChangeTab = (event: React.ChangeEvent<{}>, index: number) => {
    let url;
    if (props.viewer.role > Role.Admin) {
      url = [serviceListPath(), serviceTaxRateListPath()][index];
    } else {
      url = [
        serviceListPath(),
        servicePaymentPath(),
        serviceBusinessProfilePath(),
        serviceTaxRateListPath(),
      ][index];
    }
    if (url) router.push(url);
  };

  return {
    state: {},
    actions: {
      onChangeTab,
    },
  };
};
